import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import 'moment/locale/fr';

@Component({
  selector: 'ags-clock',
  templateUrl: './clock.component.html',
  styleUrls: ['./clock.component.scss']
})
export class ClockComponent implements OnInit {
  dayMoment: string = moment().format('dddd');
  dateMoment: string = moment()
    .format('LL')
    .slice(0, -5);
  hourMoment: string = moment().format('LT');

  constructor() {}

  ngOnInit() {
    setInterval(() => {
      this.hourMoment = moment().format('LT');
    }, 60000);
  }
}
